import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function Layout() {
  return (
    <div className='bg-primary-300 text-primary-700 transition-colors duration-300'>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
}

export default Layout;
